import { render } from "./TheHeader.vue?vue&type=template&id=63923141&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=63923141&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-63923141"

export default script